// = Libs =
import { FC } from 'react';

// = Styles =
import classes from './jumbotron.module.scss';

// = Types =
import { JumbotronProps } from './jumbotron.types';

// = Components =
import Container from '@/common/containers/container/container';
import BackButton from '@/common/components/ui/buttons/back-button/back-button';
import Icon from '@/common/components/ui/icon/icon';
import Label from '@/common/components/ui/label/label';

const Jumbotron: FC<JumbotronProps> = (props) => {
  const {
    title = 'Название страницы',
    previousPage = 'На главную',
    previousPath = '/',
    elementList = [],
    label = undefined,
    labelColor = undefined,
    subtitle = undefined,
  } = props;

  return (
    <section className={classes.jumbotron}>
      <Container>
        <div className={classes.jumbotron__content}>
          <div className={classes.jumbotron__info}>
            <BackButton previousPath={previousPath} previousPage={previousPage} lightMode={true} />

            <div className={classes.jumbotron__title}>
              {label && <Label text={label} color={labelColor} />}
              <h1 className={classes.title}>{title}</h1>
              {subtitle ? <p className={classes.subtitle}>{subtitle}</p> : ''}
            </div>

            <ul className={classes.jumbotron__list}>
              {elementList.length > 0 &&
                elementList?.map((item, index) => (
                  <li key={`${item.title}--${index}`}>
                    <Icon
                      type={item.type}
                      title={item.title}
                      subtitle={item.subtitle}
                      color={item.color}
                      className={classes['jumbotron__list-icon']}
                    />
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Jumbotron;
